export function formatDuration(ms: number): string {
  if (!ms || !Number.isFinite(ms)) return "-";
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(1)}s`;
  const m = Math.floor(s / 60);
  const rem = s - m * 60;
  return `${m}m ${rem.toFixed(0)}s`;
}

export function formatRunDate(runName: string): string {
  const match = runName.match(/^(\d{4}-\d{2}-\d{2})T(\d{2})-(\d{2})-(\d{2})/);
  if (!match) return runName;
  const [, date, hh, mm, ss] = match;
  const iso = `${date}T${hh}:${mm}:${ss}`;
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return runName;
  }
}
